import { Colors, Metrics, Typography } from "../../resources";
import { Pressable, StyleSheet, Text, ViewStyle } from "react-native";
import React, { useState } from "react";

import { SIconType } from "../../types";
import { ifElse } from "../../utils";

// react-native-web/overrides.ts
declare module "react-native" {
  interface PressableProps
    extends AccessibilityProps,
      Omit<ViewProps, "style" | "hitSlop"> {
    /**
     * Called when a single tap gesture is detected.
     */
    onMouseEnter?: null | ((event: GestureResponderEvent) => void);
    onMouseLeave?: null | ((event: GestureResponderEvent) => void);
  }
}

interface IProps {
  label: string;
  disabled?: boolean;
  containerStyle?: ViewStyle;
  onPress?: () => void;
}

const STextButton: React.FC<IProps> = ({
  label,
  disabled = false,
  containerStyle = {},
  onPress,
}) => {
  const [hover, setHover] = useState<boolean>(false);
  const [pressIn, setPressIn] = useState<boolean>(false);

  const onHoverIn = () => setHover(true);
  const onHoverOut = () => setHover(false);
  const onPressIn = () => setPressIn(true);
  const onPressOut = () => setPressIn(false);

  const color = ifElse(
    disabled,
    Colors.grey300,
    pressIn ? Colors.blue700 : Colors.blue700
  );

  return (
    <Pressable
      style={[
        styles.container,
        disabled ? {} : containerStyle,
        hover && !disabled && styles.hover,
        pressIn && !disabled && styles.pressIn,
      ]}
      onPress={onPress}
      disabled={disabled}
      onMouseEnter={onHoverIn}
      onMouseLeave={onHoverOut}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
    >
      <Text style={styles.label}>{label}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    padding: Metrics.padding6,
    borderRadius: Metrics.size4,
    backgroundColor: Colors.transparent,
  },
  pressIn: {
    backgroundColor: Colors.midnight10,
  },
  hover: {
    backgroundColor: Colors.blue100,
  },
  label: {
    ...Typography.button,
    textAlign: "center",
    textAlignVertical: "center",
    color: Colors.blue300,
  },
});

export default STextButton;
